<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
import { mdbAccordion, mdbRow, mdbCol } from 'mdbvue'
import 'mdbvue/lib/css/mdb.min.css'

export default {
  name: 'Ca',
  components: {
    mdbAccordion,
    mdbRow,
    mdbCol
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
